import auth from './auth';
import profile from './profile';

export default {auth, profile}